import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from './slices/user/userSlice';
import recordingReducer from './slices/recording/recordingSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    recording: recordingReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
